<div
  *ngIf="colVm?.columnType === productTagGroupColumnType"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section)
  "
  [scaleDownLinkedKey]="section?.id + Types.TextSizeLink.ProductTagGroup"
  class="section-header-general section-header-product-tag-group">
  {{ menu | productMenuBasicMethod: 'getProductTagGroupColumnTitle' : section : colVm : productTagGroupColumnType }}
</div>
